/*
 * View for a list of topics
 */

define([
  "marionette",
  "modules/admin/userAdministration/userList/template/userListTemplate.html",
], function (Marionette, UserListLayout) {
  var UserListView = {};

  UserListView.userListLayout = Marionette.Layout.extend({
    template: UserListLayout,
    regions: {
      users: "#allUsers",
    },
    events: {
      "input #userStatusFilter": function () {
        const userStatusFilterEl = this.$el.find("#userStatusFilter");
        this.trigger("change:userStatusFilter", +userStatusFilterEl.val());
      },
    },
  });

  return UserListView;
});
